import Box from './Box';

export default Box;